import { useCallback, useState } from 'react';
import dayjs from 'dayjs';

const lastMonth = new Date(dayjs().subtract(1, 'month').format('YYYY-MM-DD'));

const useRangeDate = (initialStartDate: Date = lastMonth) => {
    const [startDate, setStartDate] = useState<Date>(initialStartDate);
    const [endDate, setEndDate] = useState<Date>(new Date());

    const onChangeDate = useCallback((dates: [Date, Date]) => {
        // 달력 onChange
        const [start, end] = dates;

        setStartDate(start);
        setEndDate(end);
    }, []);

    return {
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        onChangeDate
    };
};

export default useRangeDate;
